import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import PersonIcon from '@mui/icons-material/Person';
import { blue } from '@mui/material/colors';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import { IUser } from '../../interface/IUser';


export interface UsersDialogProps {
  open: boolean;
  rowId: string;
  onClose: (open: boolean) => void;
  handleReassignUser: (rowId: any,userId: any) => void;  

}

export default function UsersDialog(props: UsersDialogProps) {
  const { onClose, open , rowId, handleReassignUser} = props;
  const usersinfo: IUser[] = useSelector((state: any) => state.allUsers)
  const handleClose = () => {
    onClose(false);
  };

  const _handleReassignUser = async (row: any) => {
    
    handleReassignUser(rowId ,row );
    handleClose();

  }
  
  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Reassign Users</DialogTitle>
      <List sx={{ pt: 0 }}>
        {usersinfo.map((chiled) => (
          <ListItem disablePadding >
            <ListItemButton 
              //id={chiled.id}
              onClick={(e)=>_handleReassignUser(chiled.id)}
              >
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                 <PersonIcon/>
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={chiled.userName} />
            </ListItemButton>
          </ListItem>
        ))}
        <ListItem disablePadding>
          <ListItemButton
            autoFocus
            onClick={() => handleClose()}
          >
            <ListItemAvatar>
              <Avatar>
                <CloseIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="Exit" />
          </ListItemButton>
        </ListItem>
      </List>
    </Dialog>
  );
}
